import React from "react";
import { CardWithLable, Table } from "@public/ui-toolkit";

const FundPerformance = ({ columns, data }) => {
  return (
    <CardWithLable
      title="My Funds"
      img="./assets/images/drag-icon.svg"
      alt="drag icon"
    >
      <div className="hf-card2-body px-0 pb-0">
        <div className="hf-table">
          <Table columns={columns} data={data} />
        </div>
      </div>
      <div className="hf-card2-footer">
        <div className="text-right">
          <a href="/funds" className="text-berylline text-mini">
            <u>View More</u>
          </a>
        </div>
      </div>
    </CardWithLable>
  );
};

export default FundPerformance;
